import { FC } from 'react';
import { useDragLayer } from 'react-dnd';
import { TaskItem } from '@demind-inc/core';

import { TaskCard } from '../TaskCard';
import './TaskDragPreview.scss';

const TaskDragPreview: FC = () => {
  const { isDragging, item, currentOffset, itemType } = useDragLayer((monitor) => ({
    isDragging: monitor.isDragging(),
    item: monitor.getItem() as TaskItem | null,
    itemType: monitor.getItemType(),
    currentOffset: monitor.getClientOffset(),
  }));

  if (!isDragging || !item || !currentOffset || itemType !== 'TASK') return null;

  return (
    <div
      className="task-drag-preview"
      style={{
        transform: `translate(${currentOffset.x + 12}px, ${currentOffset.y - 20}px)`,
        top: 0,
        left: 0,
      }}
    >
      <TaskCard task={item} className="task-drag-preview__card" />
    </div>
  );
};

export default TaskDragPreview;
